var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{attrs:{"object":"#dbbfa7","color1":"#ffffff","color2":"#fdf8f4","size":"5","speed":"2","bg":"#343a40","objectbg":"#999793","opacity":"5","name":"circular"}})}
var staticRenderFns = []

export { render, staticRenderFns }